import * as React from 'react';
import { connect } from 'react-redux';

import { GlobalPrivateState } from 'src/api';

import './UserList.scss';
import { requestAPIActions, RequestApiHttpPayload } from 'loopback-react-request';
import { UserListItemManage } from './UserListItemManage';
import { UserModel } from 'franke-trough-dependencies';
import { filterUsersBySword, filterUsersWithoutId } from '../utils';
import { UsersDispatcher } from 'src/app/Container';
 
export interface UserListProps {
  usersAdminList: GlobalPrivateState['users'];
  queryState: GlobalPrivateState['queryState'];
  dispatch: any;
}

export class UserListPartial extends React.Component<UserListProps, any> {
  constructor(props: UserListProps) {
    super(props);

    this.state = {
      users: filterUsersBySword(this.users, this.sword)
    }
  }

  componentDidUpdate(prevState: UserListProps) {
    const prevUsers = prevState.usersAdminList.result;
    const prevSearch = prevState.queryState.search;
    const users = this.props.usersAdminList.result;
    const search = this.props.queryState.search;

    const searchChanged = ((prevSearch && prevSearch.indexOf('sword') > -1) || (search && search.indexOf('sword') > -1)) && prevSearch !== search;
    const usersChanged = users && prevUsers !== users;

    if (searchChanged || usersChanged) {
      this.setState({
        users: filterUsersBySword(this.users, this.sword)
      });
    }
  }

  public render() {
    const users = this.state.users;

    const emailData = users && users.length > 0 && users.map((u: any) => u.email).join('\n');
    const emailDownload = new Blob([emailData], { type: 'text/plain' });

    return (
      <div className="partial-user-list">
        <UsersDispatcher />
        {users && users.length > 0 && (
          <>
            <ol className="user-list">
              <li className="user-list__header">
                <span className="user-list__first">First Name</span>
                <span className="user-list__last">Last Name</span>
                <span className="user-list__email">Email</span>
                <span className="user-list__country">Country</span>
                <span className="user-list__registration">Registered Date</span>
                <span className="user-list__labour">Labour</span>
                <span className="user-list__role">Role</span>
                <span className="user-list__action"></span>
                <span className="user-list__action"></span>
              </li>
              {users.map((user: UserModel) => (
                <UserListItemManage 
                  key={user.id} 
                  user={user} 
                  drilledRoleChange={this.onDrilledRoleChange} 
                  drilledDelete={this.onDrilledDelete} />
              ))}
            </ol>
            <div className="user-list__download">
              <a href={URL.createObjectURL(emailDownload)} download="emails.csv" className="btn btn-secondary text-white">Download emails</a>
            </div>
          </>
        )}
        {this.props.usersAdminList.result && users && users.length === 0 && (
          <h3>No users found...</h3>
        )}
      </div>
    );
  }

  get users() {
    const usersAdminList = this.props.usersAdminList.result;
    const users = usersAdminList && usersAdminList.users;
    return users;
  }

  get sword() {
    const sword = this.props.queryState.params.sword;
    return sword;
  }

  onDrilledRoleChange = (user: UserModel, newRole: string) => {
    const usersAdminList = this.props.usersAdminList.result;
    const roles = usersAdminList && usersAdminList.roles;
    const role = roles.find((r: any) => r.name === newRole);
    const roleId = role && role.id;

    const data: any = {
      roleId: roleId,
      userId: user.id
    }
    const where = Object.assign({}, data);
      delete where.roleId;

    if (newRole === 'external') {
      data.roleId = null;
      data.userId = null;
    } else {
    }
    
    this.props.dispatch(requestAPIActions.load(
      'users', {
        url: `/RoleMappings/upsertWithWhere?where=${JSON.stringify(where)}`,
        options: {
          method: 'POST',
          data
        }
      },
      false
    ));
  }

  onDrilledDelete = (user: UserModel) => {
    // Update on API
    this.props.dispatch(requestAPIActions.load<RequestApiHttpPayload>(
      'userDelete', {
        url: `/Users/${user.id}`,
        options: {
          method: 'DELETE',
        },
      },
      true
    ));

    // Update local state too
    this.setState({
      ...this.state,
      users: filterUsersWithoutId(this.state.users, user.id)
    });
  }
}

export const UserList = connect((state: GlobalPrivateState) => ({
  usersAdminList: state.users,
  queryState: state.queryState
}))(UserListPartial);

export default UserList;
